import React from "react";
import "./HomePage.css";

const PrivacyNotice = () => {
  return (
    <div className="privacy-notice">
      <h4>Privacy Notice</h4>
      <p>
        This Privacy Notice explains how Give Stream collects, uses, and
        discloses your personal information.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We collect information that you provide to us directly, such as when you
        create an account, make a donation, or contact us. This information may
        include your name, email address, payment information, and other
        personal details.
      </p>

      <h2>2. How We Use Your Information</h2>
      <p>
        We use your information to provide and improve our services, process
        your donations, communicate with you, and for other purposes described
        in this Privacy Notice.
      </p>

      <h2>3. Sharing Your Information</h2>
      <p>
        We may share your information with third parties who provide services on
        our behalf, such as payment processors, or as required by law.
      </p>

      <h2>4. Your Rights</h2>
      <p>
        You have the right to access, correct, or delete your personal
        information, and to object to or restrict certain processing of your
        information.
      </p>

      <h2>5. Data Security</h2>
      <p>
        We implement appropriate technical and organizational measures to
        protect your personal information from unauthorized access, use, or
        disclosure.
      </p>

      <h2>6. Changes to This Privacy Notice</h2>
      <p>
        We may update this Privacy Notice from time to time. We will notify you
        of any changes by posting the new notice on our platform.
      </p>

      <h2>7. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Notice, please contact us
        at [info@givestream.com].
      </p>
    </div>
  );
};

export default PrivacyNotice;
